import { useEffect, useRef, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Mic, MicOff, Video, VideoOff, PhoneOff } from 'lucide-react'

export function VideochamadaPaciente() {
  const { token } = useParams<{ token: string }>()
  const [searchParams] = useSearchParams()
  const salaUrl = searchParams.get('sala') || ''
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [micOn, setMicOn] = useState(true)
  const [cameraOn, setCameraOn] = useState(true)

  useEffect(() => {
    if (!salaUrl || !iframeRef.current) return
    // Daily.co iframe é auto-join via URL
  }, [salaUrl])

  if (!salaUrl) {
    return (
      <div className="flex h-screen items-center justify-center bg-black text-white">
        <div className="text-center">
          <p className="text-lg">Sala não encontrada.</p>
          <p className="text-sm text-gray-400 mt-2">Aguarde o médico iniciar a consulta.</p>
        </div>
      </div>
    )
  }

  const dailyUrl = `${salaUrl}?t=${encodeURIComponent(token || '')}`

  return (
    <div className="relative flex h-screen flex-col bg-black">
      {/* Daily.co iframe */}
      <iframe
        ref={iframeRef}
        src={dailyUrl}
        allow="camera; microphone; fullscreen; speaker; display-capture"
        className="flex-1 w-full border-0"
        title="Videochamada"
      />

      {/* Controles overlay */}
      <div className="absolute bottom-6 left-0 right-0 flex items-center justify-center gap-4">
        <Button
          variant={micOn ? 'secondary' : 'destructive'}
          size="lg"
          className="rounded-full h-14 w-14"
          onClick={() => setMicOn(!micOn)}
        >
          {micOn ? <Mic className="h-6 w-6" /> : <MicOff className="h-6 w-6" />}
        </Button>

        <Button
          variant={cameraOn ? 'secondary' : 'destructive'}
          size="lg"
          className="rounded-full h-14 w-14"
          onClick={() => setCameraOn(!cameraOn)}
        >
          {cameraOn ? <Video className="h-6 w-6" /> : <VideoOff className="h-6 w-6" />}
        </Button>

        <Button
          variant="destructive"
          size="lg"
          className="rounded-full h-14 w-14"
          onClick={() => window.location.href = `/teleconsulta/${token}/espera`}
        >
          <PhoneOff className="h-6 w-6" />
        </Button>
      </div>
    </div>
  )
}
